import React from 'react';
import { Activity } from 'lucide-react';
import { Link } from 'react-router-dom';

interface LogoProps {
    showText?: boolean;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

export function Logo({ showText = true, size = 'md', className = '' }: LogoProps) {
    const iconSizes = {
        sm: 20,
        md: 24,
        lg: 32
    };

    const textSizes = {
        sm: 'text-base',
        md: 'text-xl',
        lg: 'text-2xl'
    };

    return (
        <Link to="/explore">
            <div className={`flex items-center space-x-2 ${className}`}>
                {/* Logo Icon - Activity with modern styling */}
                <div className="relative">
                    <div className="absolute inset-0 bg-primary/10 rounded-lg blur-sm"></div>
                    <div className="relative bg-primary text-primary-foreground p-1.5 rounded-lg shadow-sm">
                        <Activity size={iconSizes[size]} strokeWidth={2.5} />
                    </div>
                </div>

                {/* Logo Text */}
                {showText && (
                    <span className={`font-semibold text-primary tracking-tight ${textSizes[size]}`}>
                        PlayHub
                    </span>
                )}
            </div>
        </Link>
    );
}